import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthAccessProvider } from "../core/core.auth";
import { UserContext, BaseComponent, UserInfo, PrenotazioneSala, RicercaPrenotazioniSalaRequest } from "../core/core.component";
import { MessageProvider } from "../service/message.service";
import { SalaService } from "../service/sala.service";
import { UserService } from "../service/user.service";
import { AppConstants } from "../core/app.constants";
import { SelectItem } from "primeng/primeng";
import { DatePipe } from "@angular/common";
import { UfficioService } from "app/service/ufficio.service";

@Component({
	selector: "app-elenco-sala",
	templateUrl: "./sala-elenco.component.html",
	styleUrls: ["././sala-elenco.component.css"],
})
export class ElencoSalaComponent extends BaseComponent implements OnInit {
	it: any = AppConstants.ITA_CALENDAR_CONF;
	userContext: UserContext;
	userInfo: UserInfo = new UserInfo();
	currentUser: string = null;

	completed: boolean = true;
	showFilter: boolean = false;

	// ricerca prenotazioni sala
	filtroDataDa: Date = new Date();
	filtroDataA: Date = new Date();
	filtroHrBegin: string = null;
	filtroHrEnd: string = null;
	usersSelected: SelectItem[] = [];
	allUsers: SelectItem[] = [];
	filteredUsers: SelectItem[] = [];

	prenotazioni: PrenotazioneSala[] = [];

	sortField: string = null;
	sortAsc: boolean = false;

	constructor(
		protected authAccess: AuthAccessProvider,
		protected router: Router,
		protected messageProvider: MessageProvider,
		private salaService: SalaService,
		private userService: UserService,
		private ufficioService: UfficioService,
		private datePipe: DatePipe
	) {
		super(authAccess, router, messageProvider);
		this.messageProvider.clearAll();
		this.userContext = this.authAccess.getUserContext();
		this.currentUser = this.userContext.userId;
	}

	ngOnInit() {
		this.userContext = this.authAccess.getUserContext();

		if (this.userContext == null) {
			this.authAccess.invalidate();
		} else {
			this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
				(result) => {
					this.userInfo = result;
					if (this.userInfo.managedUsers.length > 0 && this.userInfo.managedUsers.indexOf(this.userContext.userId) < 0) {
						this.userInfo.managedUsers.push(this.userContext.userId);
					}
				},
				(error) => {
					this.handleError(error);
				}
			);

			this.userService.getUsers(this.userContext.srmToken, false, false).subscribe((result) => {
				if (result && result.users) {
					result.users.forEach((user) => {
						this.allUsers.push({ label: user.fullname, value: user.id });
					});
				}
			});

			this.filtroDataA = this.calcFiltroDataDa(this.filtroDataDa, 5);
			this.ufficioService.getRefreshEvent().subscribe(() => this.reload());
			this.reload();
		}
	}

	calcFiltroDataDa(startDate: Date, numDay: number) {
		var result = 0;
		var out = new Date();
		out.setTime(startDate.getTime());
		while (result < numDay) {
			var weekDay = out.getDay();
			if (weekDay != 0 && weekDay != 6) result++;
			if (result < numDay) out.setDate(out.getDate() + 1);
		}
		return out;
	}

	toggleFilter() {
		this.showFilter = !this.showFilter;
	}

	reload() {
		let req = new RicercaPrenotazioniSalaRequest();
		req.dataDa = this.filtroDataDa;
		req.dataA = this.filtroDataA;
		//req.idSala = 1;//this.selectedStatoSala.idSala;
		this.checkHrBegin();
		this.checkHrEnd();
		if (this.filtroHrBegin != null && this.filtroHrBegin.length == 5 && this.filtroHrEnd != null && this.filtroHrEnd.length == 5) {
			req.hrBegin = this.filtroHrBegin;
			req.hrEnd = this.filtroHrEnd;
		}
		req.userIdsList = [];
		if (this.usersSelected) {
			this.usersSelected.forEach((user) => {
				req.userIdsList.push(user.value);
			});
		}

		this.completed = false;
		this.salaService.ricercaPrenotazioni(this.userContext.srmToken, req).subscribe(
			(res) => {
				if (res && res.prenotazioni) {
					this.prenotazioni = res.prenotazioni;
					if (this.sortField) {
						this.sort(this.sortField, this.sortAsc);
					}
				}
				this.completed = true;
			},
			(error) => {
				this.completed = true;
				this.handleError(error);
			}
		);
	}

	sort(field: string, directionAsc?: boolean) {
		let formatDate: string = "yyyyMMdd";
		let formatTime: string = "HHmm";
		if (field == this.sortField) {
			this.sortAsc = directionAsc != null && typeof directionAsc != "undefined" ? directionAsc : !this.sortAsc;
		} else {
			this.sortField = field;
		}

		if (this.prenotazioni) {
			this.prenotazioni.sort((p1, p2) => {
				if (this.sortField == "tsBegin") {
					let d1 = this.datePipe.transform(p1.tsBegin, formatDate);
					let d2 = this.datePipe.transform(p2.tsBegin, formatDate);
					if (d1 == d2) {
						d1 = this.datePipe.transform(p1.tsBegin, formatTime);
						d2 = this.datePipe.transform(p2.tsBegin, formatTime);
						if (d1 == d2) {
							return 0;
						}
					}
					return this.sortAsc ? (d1 > d2 ? 1 : -1) : d1 > d2 ? -1 : 1;
				}
			});
		}
	}

	filterUser(event) {
		this.filteredUsers = AppConstants.filterSuggestions(this.allUsers, event.query, item => [item.label]);
	}

	checkHrBegin() {
		this.filtroHrBegin = this.salaService.checkHours(this.filtroHrBegin);
	}

	checkHrEnd() {
		this.filtroHrEnd = this.salaService.checkHours(this.filtroHrEnd);
	}

	openLiberazioneSala(statoPrenotazioneSala: PrenotazioneSala) {
		this.salaService.openLiberazioneSala(this.filtroDataA, statoPrenotazioneSala);
	}

	openModificaPrenotazioneSala(statoPrenotazioneSala: PrenotazioneSala) {
		this.salaService.openModificaPrenotazioneSala(this.filtroDataA, statoPrenotazioneSala);
	}

	getCompleteAction(evt) {
		this.reload();
	}
}



// WEBPACK FOOTER //
// ./src/app/sala-elenco/sala-elenco.component.ts